module.exports = __webpack_public_path__ + "assets/img/37_1059.2ffe42cc.jpg";